<template>
  <div>
    <h4>{{ $t("room.illumination.flicker.percentage") }}</h4>
    <v-row class="mx-0 my-3 d-flex justify-space-between align-baseline">
      <span class="caption black20">
        {{ $t("tests.illumination.measurement_card.required") }}
      </span>
      <span class="body2">{{ requiredFlickerPercentageLabel }}</span>
    </v-row>
    <v-row class="mx-0 my-3 d-flex justify-space-between align-baseline">
      <span class="caption black20">
        {{ $t("tests.illumination.measurement_card.measured") }}
      </span>
      <span class="body2">{{ measuredFlickerPercentageLabel }}</span>
    </v-row>
  </div>
</template>

<script>
export default {
  name: "flicker-percentage-card-info",
  props: ["test"],
  computed: {
    requiredFlickerPercentageLabel() {
      const { required_flicker_percentage } = this.test;
      if (
        required_flicker_percentage === null ||
        required_flicker_percentage === undefined
      ) {
        return "-";
      }
      return `${required_flicker_percentage} %`;
    },
    measuredFlickerPercentageLabel() {
      const { measured_flicker_percentage } = this.test;
      if (
        measured_flicker_percentage === null ||
        measured_flicker_percentage === undefined
      ) {
        return "-";
      }
      return `${measured_flicker_percentage} %`;
    },
  },
};
</script>

<style scoped>
.black20 {
  color: #333333;
  font-weight: 500;
}
</style>
